import { render, staticRenderFns } from "./DataFeedReport.vue?vue&type=template&id=d357ad9a&"
import script from "./DataFeedReport.vue?vue&type=script&lang=ts&"
export * from "./DataFeedReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports